import api from "../../../../BasicComponent/Service/api";
import { QUALITY_PLAN_EXECUTION_URL } from "../../../utils/constService";

export const fetchExecutions = (params = {}) =>
  api.get(QUALITY_PLAN_EXECUTION_URL, { params });
export const fetchExecutionById = (id) =>
  api.get(`${QUALITY_PLAN_EXECUTION_URL}/${id}`);
export const postExecution = (data) =>
  api.post(QUALITY_PLAN_EXECUTION_URL, data);
export const putExecution = (data, id) =>
  api.put(`${QUALITY_PLAN_EXECUTION_URL}/${id}`, data);
export const deleteExecution = (id) =>
  api.delete(`${QUALITY_PLAN_EXECUTION_URL}/${id}`);
